import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpHeaderResponse, HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Organization } from '../store';
import { HttpService } from './http.service';

@Injectable()
export class ClubEventsService {

  private _links = [];
  //private _mainLink = { title: 'Club', url: '/my-teams' };

  private _api = '/api/club';
  private _apiAssociation = '/api/association';
  private _apiTeam = '/api/team';
  private _apiClubTeam = '/api/clubTeams';
  private _apiClubProgram = '/api/clubProgram';
  private _apiPlayer = '/api/player';
  private _apiClubParent = '/api/clubParent';
  private _apiScope = '/api/CollegeScope';
  private _apiEvent = '/api/Event';

  links: { title: string; url: any; }[];

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  //My Teams Page
  getCountryList() {
    return this.httpService.get(`${this._apiClubProgram}/get-country-list`);
  }

  getStateListByCountry(countryID: number) {
    return this.httpService.get(`${this._apiPlayer}/get-all-states-by-countryId/${countryID}`);
  }

  getClubListByState(stateID: number) {
    return this.httpService.get(`${this._api}/get-club-list-by-state/${stateID}`);
  }
  //END My Teams Page

  // Club - Event

  getClubEventTopCounts(clubID: number) {
    return this.httpService.get(this._api + '/get-club-event-top-counts/' + clubID);
  }
  getClubEventList(clubID: number, status: number) {
    return this.httpService.get(this._api + '/get-club-event-list/' + clubID + '/' + status);
  }
  getClubEventListById(clubID: number) {
    return this.httpService.get(this._api + '/get-club-event-list-by-id/' + clubID);
  }

  getFindTeamEventListNew(clubID: number) {
    return this.httpService.get(this._api + '/get-club-public-find-events/' + clubID);
  }
  getFindTeamEventList(teamID: number, teamGender: string) {
    return this.httpService.get(this._api + '/get-find-team-event-list/' + teamID + '/' + teamGender);
  }
  // END Club - Event

  // Club Event Team
  getClubEventTeamList(clubID: number, eventID: number, status: number) {
    return this.httpService.get(this._api + '/get-club-team-list-by-club-and-event/' + clubID + '/' + eventID + '/' + status);
  }
  getDivisionListByEventID(eventID: number, gender: string) {
    return this.httpService.get(this._apiTeam + '/get-division-list/' + eventID + '/' + gender);
  }
  getDivisionWithFeeAndPaymanetTypeData(eventID: number) {
    return this.httpService.get(this._apiTeam + '/get-division-with-fee-and-paymanet-type-data/' + eventID);
  }
  getEventDetailsByEvent(eventID: number) {
    return this.httpService.get(this._apiTeam + '/get-event-details-by-eventid/' + eventID);
  }
  //checkTeamDivisionWithFeeValidation(eventID: number, clubID: number, teamList: any[]) {
  //  return this.http.post(this._apiTeam + '/check-team-division-with-fee-validation/' + eventID + '/' + clubID, teamList);
  //}
  getEventPaymentInfoForClub(eventID: number, teamList: any[]) {
    return this.http.post(this._apiTeam + '/get-event-payment-info-for-club/' + eventID , teamList);
  }
  getFlightRequestList() {
    return this.httpService.get(this._apiTeam + '/get-flight-request-data');
  }
  // END Club Event Team

  // Club Event Team Payment
  getSavedCardsDetails(userID: number) {
    return this.httpService.get(this._apiPlayer + '/getSavedCardsDetails/' + userID);
  }
  addNewCard(cardData: any) {
    return this.http.post(this._apiPlayer + '/addNewCard/', cardData, { responseType: 'text' });
  }
  clubEventPaymentChargeCard(data: any) {
    return this.http.post(this._apiTeam + '/club-event-payment-charge-card/', data);
  }
  // END Club Event Team Payment

  // Club Event Team Payment
  getPaidAndUnpaidTeamListWithCount(clubID: number, eventID: number, status: number) {
    return this.httpService.get(this._api + '/get-paid-and-unpaid-team-list-with-count/' + clubID + '/' + eventID + '/' + status);
  }
  submitMyCardWhenEventTeamsApproved(eventTeamData: any, userCardID: number, status: boolean, isFree: boolean, clubDiscountCodeID: number) {
    return this.http.post(this._apiTeam + '/submit-my-card-when-event-teams-approved/' + userCardID + '/' + status + '/' + clubDiscountCodeID + '/' + isFree, eventTeamData);
  }
  // END Club Event Team Payment

  // Club Event Gane Schedule
  getClubScheduleList(clubID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-club-schedule-list/' + clubID + '/' + eventID);
  }
  getClubComplexListByClub(clubID: number) {
    return this.httpService.get(this._api + '/get-club-complex-list-by-club/' + clubID);
  }
  getVenueListByComplex(clubID: number, complexID: number) {
    return this.httpService.get(this._api + '/get-venues-by-club-and-complex/' + clubID + '/' + complexID)
  }
  getVenueListByClubComplex(clubID: number) {
    return this.httpService.get(this._api + '/get-venue-list-by-club-complex/' + clubID);
  }
  checkWorkingScheduleEnabled(eventID: number) {
    return this.httpService.get(this._api + '/check-event-working-schedule-enabled/' + eventID);
  }
  getEventScheduleDataByEventID(eventID: number) {
    return this.httpService.get(this._api + '/get-event-schedule-data-by-eventID/' + eventID);
  }
  getEventWorkingScheduleList(eventID: number, clubID: number) {
    return this.httpService.get(this._api + '/get-event-working-schedule-list/' + eventID + '/' + clubID);
  }
  saveOrUpdateWorkingSchedule(workingScheduleList: any[]) {
    return this.http.post(this._api + '/save-or-update-working-schedule', workingScheduleList);
  }
  // END Club Event Team Payment

  // Club Event Coaching Conflicts
  getCoachingConflictsData(clubID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-coaching-conflicts-data/' + clubID + '/' + eventID);
  }
  // END Club Event Team Payment

  getClubScheduleGameList(clubID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-club-schedule-game-list/' + clubID + '/' + eventID);
  }

  getGamechangeRequestData(clubID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-club-game-change-request-data/' + clubID + '/' + eventID);
  }

  enforceVenueAvailability(eventID: number) {
    return this.httpService.get(this._api + '/enforce-venue-availability/' + eventID);
  }

  getGamechangeRequestForOtherClub(clubID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-other-club-game-change-request-data/' + clubID + '/' + eventID);
  }

  approveOrDeniedGameChangeRequest(requestID: number, status: number, homeOrAway: number) {
    return this.httpService.post(this._api + '/update-game-change-request/' + requestID + '/' + status + '/' + homeOrAway);
  }

  getClubGameChangeEmailSettingsByClubIDAndEventID(clubID: number, eventID: number) {
    //return this.httpService.get(this._api + '/get-club-game-change-email-settings-by-clubID/' + clubID);
    return this.httpService.get(this._api + '/get-club-game-change-email-settings-by-clubID-and-eventID/' + clubID + '/' + eventID);
  }

  addClubGameChangeEmailSettingsSubscribers(obj: any) {
    return this.httpService.post(this._api + '/add-club-game-change-email-settings-subscribers/', obj);
  }

  removeClubGameChangeEmailSettingsSubscriber(clubUserID: number) {
    return this.httpService.delete(this._api + '/remove-club-game-change-email-settings-subscriber/' + clubUserID);
  }

  checkIsOrgClub(clubID: number) {
    return this.httpService.get(this._api + '/get-is-org-club/' + clubID);
  }

  getFindOrgEvent(clubID: number) {
    return this.httpService.get(this._api + '/get-club-public-find-org-events/' + clubID);
  }

  getOrgEventList(clubID: number, status: number) {
    return this.httpService.get(this._api + '/get-club-org-event-list/' + clubID + '/' + status);
  }

  getOrgEventTopCounts(clubID: number) {
    return this.httpService.get(this._api + '/get-club-org-event-top-counts/' + clubID);
  }

  sendGameChangeRequestData(data: any) {
    return this.httpService.post(this._api + '/send-club-game-change-data', data);
  }

  getClubStaffData(clubID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-club-staff-list/' + clubID + '/' + eventID);
  }

  getClubUserListByClubID(clubID: number) {
    return this.httpService.get(this._api + '/get-club-user-list-by-clubID/' + clubID)
  }

  getClubStaffList(clubID: number) {
    return this.httpService.get(this._apiAssociation + '/get-staffs/' + clubID + '?roleID=0')
  }

  saveClubEventUsers(obj: any) {
    return this.httpService.post(this._api + '/save-club-event-users', obj);
  }

  getReportScore(clubID: number, eventID: number) {
    return this.httpService.get(this._api + '/get-score-reporting-schedule-list/' + clubID + '/' + eventID);
  }

  getReciprocalDealData(eventID: number, clubID: number) {
    return this.httpService.get(`${this._api}/get-event-club-reciprocal-info/${eventID}/${clubID}`)
  }

  getClubReciprocalDeal(clubID: number, eventID: number) {
    return this.httpService.get(`${this._api}/get-club-reciprocal-deal/${clubID}/${eventID}`)
  }

  getPublicSingleEventDataByEventID(eventID: number) {
    return this.httpService.get(`${this._api}/get-public-single-event-data-by-eventID/${eventID}`)
  }

  //for payment history list on financial-facilities page (temporary)
  getCollegeMarketingCampaignTransactionList(collegeProgramID: number) {
    return this.http.get(this._apiScope + `/get-college-marketing-campaign-transaction-list/${collegeProgramID}`);
  }

  validateEventDiscountCode(payload: any) {
    return this.http.post(this._apiTeam + '/validate-event-discount-code/', payload);
  }

  getCollegesAttendingListWithCoachesByEvent(eventID: number) {
    return this.http.get(this._apiEvent + '/get-colleges-attending-list-with-coaches-by-event/' + eventID);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/club-events.service.ts